export default "__VITE_ASSET__FK6WOkyD__"